import { IEntityState, IProjectChild } from '../entity';
import { schema } from 'normalizr';
import { screeningSchema } from '../screening/screening.entity';
import {
  ISession,
  SessionEntityKeys,
  sessionSchema,
} from '../session/session.entity';
import { studyDetailsSchema } from '../study-details/study-details.entity';
import {
  AnnotationsKey,
  OutcomeDataKey,
  ScreeningsKey,
  SessionsKey,
  StudiesKey,
  StudyDetailsKey,
} from '@core/state/entities/entity-name-map';
import {
  MyStageWork,
  StudyBaseDto,
  StudyPdfStatus,
  StudySummaryDto,
} from '@core/services/api-client.generated';

export interface IStudy
  extends IProjectChild,
    Omit<StudySummaryDto, 'sessions' | 'screening'> {
  sessions: string[];
  screening: string;
  /**
   * The server-tracked PDF status (study management slice 8), carried by the review, Library and study detail
   * responses. Null while `studyPdfStatus` is off on the server; absent from summary responses.
   */
  pdfStatus?: StudyPdfStatus | null;
  /**
   * When a bulk PDF upload delivered the study's PDF (Studies workspace W2), carried by the Library list while
   * `studiesWorkspace` is on; null or absent otherwise.
   */
  pdfDeliveredByBulkUploadAt?: string | null;
  /**
   * The signed-in reader's own work on the study in the list's stage (#4720, the Studies workspace's "Your <stage>"
   * column), carried by the Library list while `studiesWorkspace` is on and the request names a stage; null or
   * absent otherwise.
   */
  myStageWork?: MyStageWork | null;
  /**
   * When a bulk study update locked the study (BSU-a, ADR-020): changes to it are refused until the update finishes.
   * Carried by the Library list while `studiesWorkspace` is on; null or absent otherwise.
   */
  bulkUpdateLockedAt?: string | null;
}

export const riskOfBiasPdfStatus = {
  pdfNotFound: 'PdfNotFound',
  pdfNotConverted: 'PdfNotConverted',
  textFieldGenerated: 'TextFieldGenerated',
};
interface IStudyChildEntityStateMap {
  sessions: IEntityState<ISession>;
}
export type StudyChildKeys = keyof IStudyChildEntityStateMap;

export type StudyEntityKeys =
  | StudiesKey
  | ScreeningsKey
  | StudyDetailsKey
  | SessionEntityKeys;

export const studySchema = new schema.Entity('studies', {
  screening: screeningSchema,
  sessions: [sessionSchema],
  studyDetails: studyDetailsSchema,
});
